import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';

const TESTIMONIALS = [
  {
    quote: "Found a job as a React developer within 3 weeks. The AI matching actually understood what I was looking for.",
    name:  'Arjun Sharma',
    role:  'Software Developer',
    tag:   'Job Seeker',
  },
  {
    quote: "We filled 12 positions in our Pune warehouse within 10 days. Quality of applicants was much better than we expected.",
    name:  'Priya Nair',
    role:  'HR Manager, LogiTech Solutions',
    tag:   'Recruiter',
  },
];

const LOGO_PLACEHOLDERS = Array.from({ length: 6 }, (_, i) => `Partner ${i + 1}`);

export default function TestimonialsAndLogos() {
  return (
    <section className="py-14 md:py-24 px-4 sm:px-6 bg-paper border-t border-gray-100">
      <div className="max-w-7xl mx-auto">

        <div className="text-center mb-8 md:mb-14">
          <span className="text-xs font-black tracking-widest uppercase text-brand-purple">
            Trusted by <span className="text-brand-saffron">Bharat</span>
          </span>
          <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl text-ink-900 mt-3">
            People who found their next step
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-10 md:mb-20">
          {TESTIMONIALS.map(t => (
            <div key={t.name}
                 className="p-6 md:p-8 bg-white rounded-3xl border border-gray-100 shadow-glass flex flex-col gap-4">
              <FaQuoteLeft className="text-brand-purple text-xl opacity-40" />
              <p className="text-ink-700 text-base leading-relaxed flex-1">"{t.quote}"</p>
              <div>
                <div className="font-bold text-ink-900 text-sm">{t.name}</div>
                <div className="text-xs text-ink-300">{t.role}</div>
                <span className="mt-2 inline-block px-2 py-0.5 rounded-full text-[10px]
                                 font-black tracking-wide uppercase bg-secondary-50
                                 text-brand-purple border border-secondary-100">
                  {t.tag}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* TODO: Partner logos — uncomment when real logos are available
        <div className="text-center mb-8">
          <p className="text-sm font-semibold text-ink-300 tracking-widest uppercase">
            Trusted by colleges and companies across India
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          {LOGO_PLACEHOLDERS.map(label => (
            <div key={label}
                 className="w-32 h-12 rounded-xl border border-gray-100 bg-white
                            flex items-center justify-center text-xs text-ink-300 font-semibold">
              {label}
            </div>
          ))}
        </div>
        */}

      </div>
    </section>
  );
}
